import React, { useContext } from 'react';
import Language from '../../../../common/decorators/Language';
import { getData, getRoute } from '../../../../common/utils/router';
import Single from '../../../../layouts/single/Single/Single';
import NewsComponent from '../../../../views/news/News/News';
import { getDefaultStaticProps, getLangPaths } from '../../../api/_props';
import { t } from '../../../../common/components/T';
import moment from 'moment/moment';
const project = require('../../../../scripts/configs/project');
import UserContext from '../../../../common/utils/getContext';

const NewsPageCategory = ({ news, categories, translates, newsSettings, category }) => {
    const { routerLoader } = useContext(UserContext);

    const disabledParentTransition =
        routerLoader &&
        ((routerLoader?.to?.includes(`/news/category`) && getRoute(routerLoader?.from) === '/news') ||
            (routerLoader?.from?.includes(`/news/category`) && getRoute(routerLoader?.to) === '/news') ||
            (routerLoader?.from?.includes(`/news/category`) && routerLoader?.to?.includes(`/news/category`)));

    return (
        <Language translates={translates} page={'/news'}>
            <Single
                disabledTransition={disabledParentTransition}
                seoData={{
                    seo_title: category?.data?.seo_title || category?.data?.title || category?.data?.name,
                    seo_description: category?.data.seo_description,
                    seo_keywords: category?.data.seo_keywords,
                    seo_image: category?.data.seo_image
                }}
                translates={translates}
                title={t('mainPageTitle-news', 'Новости компании', '/news', translates)}
            >
                <NewsComponent newsSettings={newsSettings} news={news} categories={categories} />
            </Single>
        </Language>
    );
};

export async function getStaticProps({ params }) {
    const defaultProps = await getDefaultStaticProps(params?.lang, `/news/category/${params?.id}`, ['/news', '/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    const { lang } = defaultProps?.props;
    const newsSettings = {
        size: 12,
        seo_url: params.id
    };

    const category = await getData(
        `/api/v1/news/categories/${newsSettings.seo_url}`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm')
    );

    if (!category?.data?.id) {
        return { notFound: true };
    }
    newsSettings.id = category.data.id;
    const categories = await getData('/api/v1/news/categories?page[size]=25', false, lang, moment().format('1DD.ss.2MM.3mm'));
    const news = await getData(
        `/api/v1/news?page[size]=${newsSettings.size}&filter[categories]=${category.data.id}`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm')
    );

    return {
        props: {
            ...defaultProps?.props,
            categories,
            news,
            newsSettings: newsSettings,
            category
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = [];
    const langs = await getLangPaths();
    const news = await getData('/api/v1/news/categories?page[size]=20', false, false, moment().format('1DD.ss.2MM.3mm'));

    langs.forEach((lang) => {
        news?.data?.forEach((newsItem) => {
            paths.push({
                ...lang,
                params: { ...lang.params, id: `${newsItem.seo_url}` }
            });
        });
    });
    return {
        paths,
        fallback: true
    };
}

export default NewsPageCategory;
